import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromAppRoot from '@app/app.reducers';

import { AuthService } from '@shared/services/auth.service';

@Injectable({
  providedIn: 'root'
})
class AuthGuardService {
  readonly authService: AuthService = inject(AuthService);
  readonly store: Store = inject(Store);
  readonly router: Router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | boolean {
    const currentPath = state.url.split('?')[0];
    const { customer_token } = route.queryParams;

    // Customer simulation and mobile/web autoLogin case
    if (customer_token) {
      return this.authService.autoLogin(route.queryParams);
    }

    if (this.authService.isLoggedIn.getValue()) {
      return this.store.select(fromAppRoot.selectEmailConfirmed).pipe(
        take(1),
        map((emailConfirmed: boolean) => {
          if (currentPath === '/next/verify-email') {
            return emailConfirmed ? this.router.parseUrl('/') : true;
          }

          return emailConfirmed ? true : this.router.parseUrl('/next/verify-email');
        })
      );
    }

    return this.authService.checkSession(state, route.queryParams);
  }
}

export const AuthGuard: CanActivateFn = (route, state) => {
  return inject(AuthGuardService).canActivate(route, state);
};
